import {select, store} from "../../store";

export const getAdmissionAuthorizationHeader = () =>
  select.admissionSession.getAuthorizationHeader(store.getState());
